module.exports = __webpack_public_path__ + "img/DSCN2035.8cfd0ec8.jpg";